<script>
import appConfig from "@/app.config";
import CustomersApi from "@/services/customers-api";
import MailMessagesApi from "@/services/mailMessages-api";
import QuillViewer from "@/components/QuillViewer";

import Swal from "sweetalert2";

export default {
  page: {
    title: "Messages",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components:{QuillViewer},

  computed: {
    agencyList() {
      try {
        return JSON.parse(process.env.VUE_APP_FEATURE_AGENCY_LIST || "[]");
      } catch (e) {
        return [];
      }
    },

    filterByAgency() {
      return this.agencyList && this.agencyList.length > 1;
    },
  },

  data() {
    return {
      subject: "",
      content: "",
      selectedCustomers: null,
      flteredCustomer: null,
      customersList: [],
      messagesList:[],
      isClaimReportingEnabled: false,
      pagemodelMain: {currentPage : 1, perPage : 10, totalRows: 0},
      startDate:null,
      endDate:null,
      role: null,
      isTableLoading: false,
      sendToAllCustomers: false,
      agencySelected: null,
      messageFields: [
                { key: "timestamp",label: "Date",thClass: "text-left",tdClass: "text-left", thStyle: "min-width:150px;"},
                { key: "subject", label: "Objet", thClass: "text-left", tdClass: "text-left ", thStyle:"min-width:220px;" },
                { key: "attachmentName", label: "Pièce jointe", thClass: "text-left", tdClass: "text-left " , thStyle:"min-width:350px;" },
                { key: "customerName", label: "Client", thClass: "text-center", tdClass: "text-center"},
                { key: "actions", label: "", thClass: "text-center", tdClass: "text-center"}
      ],

      selectedMessage: null,
      showMessageModal: false,
      mailAttachment: null

    };

  },

  watch: {
    startDate: function() {
      this.findAllMessages();
    },
    endDate: function() {
      this.findAllMessages();
    },
    sendToAllCustomers: function(value) {
      if (!value) {
        this.agencySelected = null;
      }
    }
  },

  mounted() {
    this.role = sessionStorage.getItem("userr")
    this.getCustomers()
    this.findAllMessages()
  },

  methods: {

    downloadAttachment(id){
      MailMessagesApi.downloadAttachment(id)
    },

    openMessage(message) {
      this.selectedMessage = message;
      this.showMessageModal = true;
    },

    closeMessageModal() {
      this.showMessageModal = false;
      this.selectedMessage = null;
    },

    createMailMessage() {
      const swalText = this.sendToAllCustomers
        ? "Ce message sera envoyé à <strong style='text-transform:uppercase'>tous les clients inscrits</strong> sur la plateforme. Continuer ?"
        : "Ce message sera envoyé aux <strong style='text-transform:uppercase'>client(s) sélectionné(s)</strong>. Continuer ?";

      Swal.fire({
        html: swalText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Envoyer",
        cancelButtonText: "Annuler",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        reverseButtons: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendMessage();
        }
      });
    },

    // API CALL //

    getCustomers(){
      CustomersApi.getCustomers().then(
          response => {
          this.customersList=response;
          }
      )
    },

    findAllMessages() {
      this.isTableLoading = true;
      MailMessagesApi.getMails(this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.startDate,this.endDate,this.flteredCustomer ? this.flteredCustomer.id : null).then(
        response => {
          this.messagesList=response.list;
          this.pagemodelMain.totalRows = response.total;
          this.pagemodelMain.currentPage = response.page;
          this.pagemodelMain.perPage = response.pageSize;
          this.pagemodelMain.pageSize = response.pageSize;
        }
      ).finally(() => {
        this.isTableLoading = false;
      });
    },

    clearMailMessage(){
      this.subject= ""
      this.content= ""
      this.sendToAllCustomers= false
      this.agencySelected= null
      this.customerIds= []
      this.selectedCustomers= []
      this.mailAttachment= null
    },

    sendMessage() {
      this.isTableLoading = true;

      const customerIds = this.sendToAllCustomers
        ? null
        : this.selectedCustomers?.length
          ? this.selectedCustomers.map(c => c.id)
          : null;

      const formData = new FormData();

      if (this.subject != null) formData.append("subject", this.subject);
      if (this.content != null) formData.append("content", this.content);
      if (this.sendToAllCustomers != null) formData.append("isSendToAllCustomers", this.sendToAllCustomers);
      if (this.sendToAllCustomers && this.agencySelected && this.agencySelected.id != null) formData.append("dbAgencyId", this.agencySelected.id);

      if (customerIds && customerIds.length > 0) {
        customerIds.forEach(id => {
          if (id != null) formData.append("customerIds", id);
        });
      }

      if (this.mailAttachment) {
        formData.append("attachment", this.mailAttachment);
      }

      MailMessagesApi.createMailMessage(formData)
        .then(response => {
          this.messagesList = response.list;
          this.pagemodelMain.totalRows = response.total;
          this.pagemodelMain.currentPage = response.page;
          this.pagemodelMain.perPage = response.pageSize;
          this.pagemodelMain.pageSize = response.pageSize;

          this.clearMailMessage()
        })
        .finally(() => {
          this.isTableLoading = false;
        });
    },
  },
};
</script>

<template>

    <div>

      <div class="row">
        <div class="col-md-8 col-sm-12">
          <h3 class="card-title text-primary" style="font-size:1.5em;">
            Nouveau Message
          </h3>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-2 col-xs-0"></div>

        <div class="col-lg-6 pt-4 mr-4 col-11 col-md-8">
          <div class="col-12 position-relative col-sm-11 col-md-12">
            <b-form-group label-for="" class="mt-2 mb-0">
              <label>
                <span style="color: black">Objet</span><span class="text-danger"> *</span>
              </label>
              <b-form-input v-model="subject" :maxlength="50" class="form-control font-size-14 mr-4" placeholder="Objet"/>
            </b-form-group>

            <div class="row mt-4">
              <div class="col-md-6 col-12">
                <b-form-group class="mb-0">
                  <b-form-checkbox v-model="sendToAllCustomers">
                    Envoyer ce mail à tous les clients
                  </b-form-checkbox>
                </b-form-group>
              </div>
              <div class="col-md-6 col-12" v-if="filterByAgency">
                <b-form-group class="mb-0">
                  <label>
                    <span style="color: black">Envoyer ce mail à tous les clients de cette agence</span>
                  </label>
                  <v-select
                    id="agency-filter"
                    class="style-vselect-big"
                    style="font-size:1.2em;"
                    :options="agencyList"
                    placeholder="Toutes les agences"
                    label="name"
                    v-model="agencySelected"
                    :disabled="!sendToAllCustomers"
                  >
                    <span slot="no-options">
                      {{$t('lists.emptyLists.label')}}
                    </span>
                  </v-select>
                </b-form-group>
              </div>
            </div>
            

            <b-form-group label-for="" class="mt-2 mb-0">
              <label>
                <span style="color: black">Client</span>
              </label>
              <div class="col-12 text-right">
                <v-select
                  class="" style="font-size:1.2em;"
                  :options="customersList"
                  placeholder="Clients"
                  label="name"
                  v-model="selectedCustomers"
                  multiple
                  :disabled="sendToAllCustomers"
                >
                  <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
              </div>
            </b-form-group>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-2 col-xs-0"></div>
        <div class="col-lg-8 col-md-10 col-xs-12">
          <b-form-group label-for="attachment" class="mt-4 mb-0">
            <b-form-file
              id="attachment"
              v-model="mailAttachment"
              placeholder="Choisir un fichier..."
              drop-placeholder="Déposez le fichier ici..."
              browse-text="Parcourir"
            ></b-form-file>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-2 col-xs-0"></div>
        <div class="col-lg-8 col-md-10 col-xs-12">
          <b-form-group label-for="" class="mt-4 mb-0">
            <label>
              <span style="color: black">Message</span><span class="text-danger"> *</span>
            </label>
            <QuillViewer v-model="content"></QuillViewer>
          </b-form-group>
        </div>
      </div>

      <div class="row pt-3">
        <div class="col-md-7 col-sm-9 col-xs-0"></div>
        <div class="col-sm-3 col-xs-12">
          <b-button variant="primary" class="w-100 font-weight-bold" @click="createMailMessage" :disabled="!sendToAllCustomers && (!selectedCustomers || selectedCustomers.length===0) || !subject || !content">
            <i class="fas fa-paper-plane align-middle mr-2 ml-2"></i> Envoyer
          </b-button>
        </div>
      </div>


      <hr class="my-5">


      <div class="row">
        <div class="col-md-8 col-sm-12">
          <h3 class="card-title text-primary" style="font-size:1.5em;">
            Liste des Messages
          </h3>
        </div>
      </div>

      <!-- Filters -->
      <div class="row mt-4">
        <div class="col-md-4 col-12  pr-md-2 pr-0" v-if="role && role == 2">
          <label>Client</label>
          <v-select
          class="style-vselect-big" style="font-size:16px;"
            placeholder="Clients"
            :options="customersList"
            label="name"
            v-model="flteredCustomer"
            @input="findAllMessages"
          />
        </div>

        <div class="col-md-4 col-12 pl-md-2 pl-0 pr-md-2 pr-0">
          <label>Date début</label>
          <b-form-datepicker
            v-model="startDate"
            locale="fr"
            label-no-date-selected="Date Début"
            dark
            reset-button
            close-button
            label-reset-button="Réinitialiser"
            label-close-button="Fermer"
            dropright
            hide-header
          />
        </div>

        <div class="col-md-4 col-12  pl-md-2 pl-0 ">
          <label>Date fin</label>
          <b-form-datepicker
            v-model="endDate"
            locale="fr"
            label-no-date-selected="Date Fin"
            dark
            reset-button
            close-button
            label-reset-button="Réinitialiser"
            label-close-button="Fermer"
            dropright                         
            hide-header
          />
        </div>
      </div>

      
      <!-- Table -->
      <div class="row pt-4">
        <div class="table-responsive col-12">
          <b-table
            :busy="isTableLoading"
            :items="messagesList"
            :fields="messageFields"
            striped
            hover
          >
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner variant="primary" />
              </div>
            </template>

            <template #cell(content)="{ value }">
              <span class="truncate-title">{{ value }}</span>
            </template>

            <template #cell(subject)="{ item }">
              <span class="font-size-14" >{{ item.subject }}</span>
            </template>

            <template #cell(timestamp)="{ item }">
              <span class="font-size-14" >{{ item.timestamp }}</span>
            </template>

            <template #cell(customerName)="{ item }">
              <div class="d-flex flex-wrap justify-content-center">
                <b-badge
                  v-if="item.isSendToAllCustomers || !item.customersName || !item.customersName.length"
                  variant="primary"
                  class="mr-1 mb-1"
                >
                  TOUT
                </b-badge>

                <b-badge
                  v-else
                  variant="info"
                  class="mr-1 mb-1"
                >
                  {{ item.customersName.length }}
                </b-badge>
              </div>
            </template>

            <template #cell(attachmentName)="{ item }">
              <div v-if="item.attachment" class="d-flex justify-content-left gap-2" style="cursor: pointer;" @click="downloadAttachment(item.id)">
                  <i class="fas fa-download text-primary mr-2"> </i>{{ item.attachmentName ? item.attachmentName : "-" }}
              </div>
            </template>

            <template #cell(actions)="{ item }">
              <div class="d-flex justify-content-center align-items-center gap-2">
                  <i class="mdi mdi-eye text-primary font-size-14" style="cursor: pointer;" @click="openMessage(item)"></i>
              </div>
            </template>

          </b-table>

          <div v-if="!isTableLoading && !messagesList.length"
              class="text-center text-danger mt-4">
            Aucun message trouvé
          </div>
        </div>
      </div>


        <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="findAllMessages()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelMain.currentPage" :disabled="isTableLoading" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findAllMessages()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->




    <b-modal
      v-model="showMessageModal"
      :title="'Objet : ' + (selectedMessage && selectedMessage.subject ? selectedMessage.subject : '')"
      size="lg"
      hide-footer
      centered
    >
      <div v-if="selectedMessage">

       

        <div class="row mb-3">
          <div class="col-md-8">
            <strong>Client</strong>
            <div class="font-size-14 mt-1">
              <b-badge
                v-for="(name, index) in selectedMessage.customersName"
                :key="index"
                variant="primary"
                class="mx-1 mb-1"
              >
                {{ name }}
              </b-badge>
              <span v-if="!selectedMessage.customersName || !selectedMessage.customersName.length">-</span>
            </div>
          </div>

          <div class="col-md-4">
            <strong>Date</strong>
            <div class="font-size-14 mt-1">{{ selectedMessage.timestamp }}</div>
            <div v-if="selectedMessage.generationTimeStamp" class="text-secondary">
              <i>Généré le {{ selectedMessage.generationTimeStamp }}</i>
            </div>
          </div>
          
        </div>

         <div class="mb-3">
          <strong>Objet :</strong>
          <div class="mt-2 font-size-14">
            {{ selectedMessage.subject }}
          </div>
        </div>

        <div class="mb-3">
          <strong>Message :</strong>
          <div class="border rounded p-3 mt-2 font-size-16" style="white-space: pre-line;" v-html="selectedMessage.content">
          </div>
        </div>

        

      </div>
    </b-modal>


    </div>
</template>

<style>
.truncate-title {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



<style scoped>
  
    .style-vselect-big .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

   

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.6;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }
</style>